import React from 'react';
import PropTypes from 'prop-types';

const OptionList = (props) => {
    const {
        children, show, reference,
        showAsDropdown, optionsWrapperClass,
    } = props;
    const className = `
        options-list-wrapper 
        ${!show ? 'hidden' : ''} 
        ${showAsDropdown ? 'show-as-dropdown' : ''}
        ${optionsWrapperClass}
    `;

    return (
        <div className="search-box-options-list-wrapper">

            <div
                className={className}
                ref={reference}
                tabIndex={-1}
            >
                {children}
            </div>
        </div>
    );
};

OptionList.defaultProps = {
    children            : {},
    show                : false,
    reference           : null,
    showAsDropdown      : false,
    optionsWrapperClass : '',
};

OptionList.propTypes = {
    children            : PropTypes.node,
    show                : PropTypes.bool,
    // empty ref shape because of this https://github.com/facebook/prop-types/issues/240
    reference           : PropTypes.shape({}),
    showAsDropdown      : PropTypes.bool,
    optionsWrapperClass : PropTypes.string,
};

export default OptionList;
